import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=5641bf5c&name=modal"
import script from "./modal.ts?vue&type=script&lang=src&external"
export * from "./modal.ts?vue&type=script&lang=src&external"
import style0 from "./modal.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports